export default __webpack_public_path__ + ".well-known/manifest.json";